import classNames from 'classnames';
import React, { useCallback, useRef, useState } from 'react';
import { HasClassName } from '../component-utils';
import './DropdownButton.scss';
import { ReactComponent as DropdownIcon } from './icons/dropdown-icon.svg';
import { Menu } from './Menu';

interface Props extends HasClassName {
  activeClassName?: string
  disabled?: boolean
  items: React.ReactNode
  setWidth?: boolean
  title?: string
  menuClassName?: string
  caret?: boolean
}

export default function DropdownButton({ className, disabled, activeClassName, items, children, setWidth, title, caret, menuClassName }: React.PropsWithChildren<Props>) {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLButtonElement>(null)

  return <div title={title} className={classNames('DropdownButton', className, disabled && 'disabled', open && activeClassName, (caret !== undefined || caret === false) && 'none-caret')} onClick={() => {
    if (!disabled) {
      setOpen(x => !x)
    }
  }}>
    <button aria-pressed={open} ref={ref}>
      <div className='content'>
        {children}
      </div>
      {(caret === undefined || caret === true) && <DropdownIcon className='caret' />}
    </button>
    <Menu className={menuClassName} open={open} onClose={useCallback(() => setOpen(false), [])} target={ref.current} placement='bottom-end' setWidth={setWidth}>
      {items}
    </Menu>
  </div>
}

